@import '../../../styles/palette.less';

fluid-tab-navigation {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .tabs-nav-container {
    min-width: 3em;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;

    &.nav-left {
      left: 0;
      justify-content: flex-start;
      @left-background-gradient();
    }

    &.nav-right {
      right: 0;
      justify-content: flex-end;
      @right-background-gradient();
    }
  }

  .tabs-nav-btn {
    @button-reset();
    width: 2em;
    height: 100%;
    display: flex;
    align-items: center;

    &.nav-left {
      justify-content: flex-start;
    }

    &.nav-right {
      justify-content: flex-end;
    }

    fluid-icon {
      color: @liberty-gray-69; // Sets FLUID Icon "fill" color
    }
  }
}


// ================================================================ //
// -- Detached Ruleset Helper(s)

@button-reset: {
  background-color: transparent;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
};

@left-background-gradient: {
  background: -moz-linear-gradient(left, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 0.06) 86%, rgba(255, 255, 255, 0) 89%, rgba(255, 255, 255, 0) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 0.06) 86%, rgba(255, 255, 255, 0) 89%, rgba(255, 255, 255, 0) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 0.06) 86%, rgba(255, 255, 255, 0) 89%, rgba(255, 255, 255, 0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1); /* IE6-9 */
};

@right-background-gradient: {
  background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 11%, rgba(255, 255, 255, 0.06) 14%, rgba(255, 255, 255, 1) 65%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 11%, rgba(255, 255, 255, 0.06) 14%, rgba(255, 255, 255, 1) 65%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 11%, rgba(255, 255, 255, 0.06) 14%, rgba(255, 255, 255, 1) 65%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1); /* IE6-9 */
};
